<template>
  <tr>
    <td v-if="isEditing">
      <input type="text" name="" v-model="occupationEditing.name" class="form-control">
      <div class="pull-right">
        <a href="#" class="text-primary" @click="update">{{ $t('buttons.save') }}</a>
        <span class="m-l-5 m-r-5">|</span>
        <a href="#" class="text-danger" @click="cancel">{{ $t('buttons.cancel') }}</a>
      </div>
    </td>
    <td v-else>{{ occupation.name }}</td>
    <td class="p-t-5 p-b-5 v-align-middle">
      <div class="btn-toolbar flex-wrap">
        <div class="btn-group">
          <a href="#edit" class="btn btn-icon" @click.prevent="edit">
            <i class="fa fa-edit"></i>
          </a>
          <a href="#delete" class="btn btn-icon-dark" @click.prevent="confirmDeleteOccupation">
            <i class="fa fa-trash-o"></i>
          </a>
        </div>
      </div>
    </td>
  </tr>
</template>

<script type="text/javascript">
  import { mapActions } from 'vuex'

  export default {
    props: ['occupation', 'currentEntity'],
    data() {
      return {
        isEditing: false,
        occupationEditing: {}
      }
    },
    methods: {
      ...mapActions({
        getDestroyOccupationPermission: 'occupations/getDestroyOccupationPermission',
        deleteOccupation: 'occupations/delete'
      }),
      edit() {
        this.occupationEditing = Object.assign({}, this.occupation)
        this.isEditing = true
      },
      update() {
        this.$store.dispatch('occupations/update', { ...this.occupationEditing, entity_id: this.currentEntity.id })
          .then((result) => {
            if(result.updated){
              this.isEditing = false
            }
          })
      },
      cancel() {
        this.isEditing = false
      },
      confirmDeleteOccupation() {
        var self = this;
        this.getDestroyOccupationPermission(this.occupation).then((response) => {
          if(response.status == 200 && response.data.can_delete) {
            this.$dialog.confirm(self.deleteMessageConfirmation).then(() => {
              self.deleteOccupation({ ...self.occupation, entity_id: this.currentEntity.id })
            })
          } else if (response.data.type == 'user') {
            this.$dialog.alert(this.$i18n.t('Occupations.messages.occupation_relates_users'))
          } else {
            this.$dialog.alert(this.$i18n.t('Occupations.messages.occupation_has_acitve_offers'))
          }
        })
      }
    },
    computed: {
      deleteMessageConfirmation(){
        return this.$i18n.t('messages.delete_confirmation', {'resource': this.$i18n.t('resources.occupation'), 'name': this.occupation.name})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/occupations/Occupation.vue